import Configuration from '@/agilis/util/Configuration'
import { mapGetters } from 'vuex'
import EntityDetails from '@/agilis/components/EntityDetails/EntityDetails.vue'

export default {
  name: 'TrackerParent',

  components: {
    EntityDetails
  },

  props: {
    trackerDTO: Object,
    open: Boolean, // automatically open on mount
    formRows: Array // custom formRows specified by the parent component; when not specified, will read from tracker configuration
  },

  computed: {
    ...mapGetters({
      'applicationId': 'contextStore/applicationId'
    }),

    jlAssertionContext () {
      return {
        tracker: this.trackerDTO
      }
    },

    computedParentTitle () {
      const trackerTypeId = this.trackerDTO?.trackerTypeId
      const parentLabel = trackerTypeId && this.$t(Configuration.getApplication(this.applicationId).trackerTypes[trackerTypeId].name)
      const title = this.$t('label.parentDetails', { parent: parentLabel })
      return Configuration.i18n.capitalizePhrase(title)
    }
  }
}
